import React from "react";
import { Box, Avatar, Typography } from "@mui/material";
import Icon1 from "../icons/Icon";
import { useTheme } from "@mui/material";

const ListCellOrg = ({ org, removable, onDelete, icon_name = "expert" }) => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        padding: "7px",
        borderBottom: "1px solid #e0e0e0", // Adds a separator between items
        width: "100%",
      }}
    >
      {/* User Avatar and Email */}
      <div className="flex flex-row gap-2">
        <img
          src={org.logo || "https://i.ibb.co/xqZTQvtX/image.png"}
          alt="photo"
          className="h-10 w-10 rounded-full object-contain"
        />{" "}
        <div className="flex flex-col">
          <div className="text-h3">{org.name}</div>{" "}
          <div className="text-h5 text-nowrap text-clip max-w-full overflow-hidden text-shadow_50">
            {org.email}
          </div>
        </div>
      </div>

      {/* Close Icon (Removable functionality) */}
      {removable && (
        <Box
          className="cursor-pointer"
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          onClick={() => onDelete(org)}
        >
          <Icon1
            icon_name="delete"
            height="16px"
            width="16px"
            hover_color={"red"}
            fill={"grey"}
          />
        </Box>
      )}
    </Box>
  );
};

export default ListCellOrg;
